import { create } from 'zustand';

interface ImageCoordinates {
  eventValueId: string;
  topPct: number;
  leftPct: number;
  widthPct: number;
  heightPct: number;
}

export interface OffenderState {
  addingOffender: boolean;
  offenderImage: string;
  imageCoordinates?: ImageCoordinates;
  isDrawMode: boolean;
  flashOverlay: number;
  setAddingOffender: (adding: boolean) => void;
  setOffenderImage: (image: string) => void;
  setImageCoordinates: (coordinates?: ImageCoordinates) => void;
  setDrawMode: (drawMode: boolean) => void;
  triggerFlash: () => void;
  reset: () => void;
}

// TODO: This should probably be moved into the AlertProvider ctx
// since it's not meant to be global
export const useOffenderStore = create<OffenderState>((set) => ({
  addingOffender: false,
  offenderImage: '',
  imageCoordinates: undefined,
  isDrawMode: false,
  flashOverlay: 0,
  setAddingOffender: (adding) => set({ addingOffender: adding }),
  setOffenderImage: (image) => set({ offenderImage: image }),
  setImageCoordinates: (coordinates) => set({ imageCoordinates: coordinates }),
  setDrawMode: (drawMode) => set({ isDrawMode: drawMode }),
  triggerFlash: () => set((state) => ({ flashOverlay: state.flashOverlay + 1 })),
  reset: () =>
    set({
      addingOffender: false,
      offenderImage: '',
      imageCoordinates: undefined,
      isDrawMode: false,
      flashOverlay: 0,
    }),
}));
